
import React from 'react';



//import WorkList from './WorkList';


class GoogleAnalytics extends React.Component{

  constructor(){
    super();


    this.state = {
      trackingLocation: ''
    }

    this.checkLocation = this.checkLocation.bind(this)

    this.checkLocationInterval = ''

  }



  componentDidMount(){
      this.checkLocationInterval = setInterval(this.checkLocation,100)
      ///this.track();
  }
  componentWillUnmountMount(){
      clearInterval(this.checkLocationInterval);
  }

  checkLocation(){
    if(this.state.trackingLocation!==window.location.pathname){
      this.setState({trackingLocation:window.location.pathname})
    }
  }


  shouldComponentUpdate(newProps,newState){
      if(newState.trackingLocation===this.state.trackingLocation){
        return false;
      }else{
        return true;
      }
  }

  componentDidUpdate(){
    this.track();

  }

  track(){
    // only track on territoryprojects.com or .co.uk
    //if(window.location.origin.indexOf('territoryprojects')!==-1){
      console.log("Track Page View: ",this.state.trackingLocation);
      try{
      window.ga('send', {
          hitType: 'pageview',
          page: window.location.pathname
        });
      //}
    }catch(e){
      console.warn("GoogleAnalytics not ready");
    }
  }

  render () {
    return null
  }
}

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./src/modules/misc/GoogleAnalytics.js